var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1969 0.703046C11.9761 0.273407 11.5095 0 10.997 0C10.4846 0 10.0221 0.273407 9.79714 0.703046L7.11826 5.87044L1.13556 6.69847C0.635617 6.76877 0.218995 7.09686 0.064845 7.54603C-0.0893052 7.9952 0.0356813 8.49124 0.393976 8.82323L4.73518 12.8501L3.71029 18.5409C3.62696 19.0096 3.83527 19.4861 4.24773 19.7634C4.66019 20.0407 5.20596 20.0759 5.65591 19.8532L11.0012 17.1778L16.3464 19.8532C16.7964 20.0759 17.3422 20.0446 17.7546 19.7634C18.1671 19.4822 18.3754 19.0096 18.2921 18.5409L17.263 12.8501L21.6042 8.82323C21.9625 8.49124 22.0917 7.9952 21.9333 7.54603C21.775 7.09686 21.3626 6.76877 20.8626 6.69847L14.8758 5.87044L12.1969 0.703046Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star-solid.376ba7c685c4fb82d6e1d46a615bb630.svg";
export { ForwardRef as ReactComponent };